import { ResponseState } from 'src/types/auth';
import PKCE from '../auth/challenge-code';
import { AUTH_HOST } from '../auth/auth-host';
const config = process.env;

export const redirectToLogin = (responseState?: ResponseState) => {
  const {
    REACT_APP_AUTH_TENANT,
    REACT_APP_AUTH_POLICY,
    REACT_APP_AUTH_CLIENT_ID,
  } = config;

  const url = new URL(
    `https://${AUTH_HOST}/${REACT_APP_AUTH_TENANT}.onmicrosoft.com/${REACT_APP_AUTH_POLICY}/oauth2/v2.0/authorize`
  );
  const urlParams = new URLSearchParams();
  urlParams.set('client_id', REACT_APP_AUTH_CLIENT_ID!);
  urlParams.set('response_type', 'code');
  urlParams.set('redirect_uri', `${window.location.origin}/auth/callback`);
  urlParams.set('scope', 'openid');
  responseState && urlParams.set('state', JSON.stringify(responseState));
  urlParams.set('nonce', '12345');
  urlParams.set('code_challenge', PKCE.challenge);
  urlParams.set('code_challenge_method', 'S256');

  sessionStorage.setItem('lccv', PKCE.verifier);

  url.search = urlParams.toString();
  window.location.replace(url.toString());
};
